import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { handleNumberOnly, isPlaca, upperCase, validarCPFCNPJ } from "../../../utils/utils";
import { useState } from "react";
import { ReboqueInterface } from "../../../interfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { addTracaoReboque, removeTracaoReboque } from "../../../features/manifestoSlice";

const initialReboque = {
    placa: '',
    tpCar: '2',
    uf: '',
    tara: 0,
    capKG: 0,
    capM3: 0,
    cint: '',
    id: 0,
    renavam: '',
    prop: false,
    prop_cpfcnpj: '',
    prop_rntrc: '',
    prop_xNome: '',
    prop_ie: '',
    prop_uf: '',
    prop_tpProp: 0,
}

export default function Reboques() {
    const [formReboque, setFormReboque] = useState<ReboqueInterface>(initialReboque);
    const selectEstados = useSelector((state: RootState) => state.manifesto.selectEstados);
    const listaReboques = useSelector((state: RootState) => state.manifesto.manifesto.modal_rodoviario.reboques);
    const [showModal, setShowModal] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');
    const [selected, setSelected] = useState('');
    const dispatch = useDispatch();

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setFormReboque((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleOpenModal = (placa: string) => {
        setSelected(placa);
        setShowModal(true);
    }

    const validarCampos = () => {

        if (formReboque.placa === "") {
            setMessageAlert('Informe a placa.');
            setShowAlert(true);
            return false;
        }

        if (!isPlaca(formReboque.placa)) {
            setMessageAlert('Placa inválida.');
            setShowAlert(true);
            return false;
        }

        if (formReboque.tara <= 0) {
            setMessageAlert('Informe a Tara(kg).');
            setShowAlert(true);
            return false;
        }

        if (formReboque.capKG <= 0) {
            setMessageAlert('Informe a Capacidade(kg).');
            setShowAlert(true);
            return false;
        }

        if (formReboque.uf === '') {
            setMessageAlert('Informe a UF do reboque');
            setShowAlert(true);
            return false;
        }

        if (formReboque.prop) {

            if (formReboque.prop_rntrc === '') {
                setMessageAlert('Informe o RNTRC');
                setShowAlert(true);
                return false;
            }

            if (formReboque.prop_uf === '') {
                setMessageAlert('Informe a UF do proprietário');
                setShowAlert(true);
                return false;
            }

            if (formReboque.prop_xNome === "") {
                setMessageAlert('Informe o Nome do proprietário.');
                setShowAlert(true);
                return false;
            }

            if (formReboque.prop_cpfcnpj === "") {
                setMessageAlert('Informe o CPF/CNPJ do proprietário.');
                setShowAlert(true);
                return false;
            }


            if (!validarCPFCNPJ(formReboque.prop_cpfcnpj || '')) {
                setMessageAlert('CPF/CNPJ inválido.');
                setShowAlert(true);
                return false;
            }

        }

        if (listaReboques.find((item: ReboqueInterface) => item.placa === formReboque.placa)) {
            setMessageAlert('Reboque já adicionado com a placa ' + formReboque.placa + '.');
            setShowAlert(true);
            return false;
        }

        if (listaReboques.length >= 3) {
            setMessageAlert('Número máximo de reboques atingido!');
            setShowAlert(true);
            return false;
        }

        return true;
    }

    const handleAddReboque = () => {
        if (validarCampos()) {
            dispatch(addTracaoReboque(formReboque))
            setFormReboque(initialReboque)
        }
    }

    const handleRemoveReboque = (placa: string) => {
        if (listaReboques.length > 0) {
            dispatch(removeTracaoReboque(placa));
            setShowModal(false);
        }
    }

    return (<>


        <Row className="g-2 mb-3">
            <Col md>
                <Form.Group>
                    <Form.Label>Código do veículo</Form.Label>
                    <Form.Control name="cint" type="text" value={formReboque.cint}
                        onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={10} />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>Tipo Carroceria</Form.Label>
                    <Form.Select name="tpCar" onChange={handleChange} value={formReboque.tpCar}>
                        <option value="0">0 - Não Aplicável</option>
                        <option value="1">1 - Aberta</option>
                        <option value="2">2 - Fechada/Baú</option>
                        <option value="3">3 - Granelera</option>
                        <option value="4">4 - Porta Container</option>
                        <option value="5">5 - Sider</option>
                    </Form.Select>
                </Form.Group>
            </Col>

            <Col md={'auto'}>
                <Form.Group>
                    <Form.Label>*Placa</Form.Label>
                    <Form.Control name="placa" type="text" value={formReboque.placa}
                        onChange={handleChange} maxLength={7} onKeyUp={upperCase} />
                </Form.Group>
            </Col>

        </Row>

        <Row className="g-2 mb-3">
            <Col md>
                <Form.Group>
                    <Form.Label>* Tara(kg)</Form.Label>
                    <Form.Control name="tara" type="text" min={0} value={formReboque.tara}
                        onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={6} />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>RENAVAM</Form.Label>
                    <Form.Control name="RENAVAM" type="text" value={formReboque.renavam}
                        onChange={handleChange} maxLength={11} />
                </Form.Group>
            </Col>


            <Col md>
                <Form.Group>
                    <Form.Label>* Capacidade(kg)</Form.Label>
                    <Form.Control name="capKG" type="text" min={0} value={formReboque.capKG}
                        onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={6} />
                </Form.Group>
            </Col>

            <Col md>
                <Form.Group>
                    <Form.Label>Capacidade(M³)</Form.Label>
                    <Form.Control name="capM3" type="text" min={0} value={formReboque.capM3}
                        onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={3} />
                </Form.Group>
            </Col>

            <Col md={'auto'}>
                <Form.Group>
                    <Form.Label>UF</Form.Label>
                    <Form.Select name="uf" onChange={handleChange} value={formReboque.uf} >
                        {selectEstados?.map((estado) => {
                            return <option key={estado.id} value={estado.uf}>{estado.uf}</option>
                        })}
                    </Form.Select>
                </Form.Group>
            </Col>

        </Row>

        <Row className="g-2 mb-3">
            <Col md className="">
                <Form.Group className="" controlId="active">
                    <Form.Switch type="switch" checked={formReboque.prop}
                        onChange={(e) => setFormReboque({ ...formReboque, prop: e.target.checked })}
                        name="active" label="O proprietário não é emitente iniciado no aplicativo?" />
                </Form.Group>
            </Col>

        </Row>

        {formReboque.prop && (
            <>
                <Row className="g-2 mb-3">
                    <Col md>
                        <Form.Group>
                            <Form.Label>*RNTRC</Form.Label>
                            <Form.Control type="text" name="prop_rntrc"
                                onChange={handleChange} value={formReboque.prop_rntrc}
                                maxLength={8}
                            />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group>
                            <Form.Label>Tipo Proprietário</Form.Label>
                            <Form.Select name="prop_tpProp" value={formReboque.prop_tpProp}
                                onChange={handleChange} >
                                <option value="0">0 - TAC Agregado</option>
                                <option value="1">1 - TAC Independente</option>
                                <option value="2">2 - Outros</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md={'auto'}>
                        <Form.Group>
                            <Form.Label>UF</Form.Label>
                            <Form.Select name="prop_uf" value={formReboque.prop_uf} onChange={handleChange}>
                                {selectEstados?.map((estado) => {
                                    return <option key={estado.id} value={estado.uf}>{estado.uf}</option>
                                })}

                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="g-2 mb-3">
                    <Col md>
                        <Form.Group>
                            <Form.Label>*Nome do proprietário</Form.Label>
                            <Form.Control type="text" name="prop_xNome"
                                value={formReboque.prop_xNome} onChange={handleChange}
                                maxLength={60}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>*CPF/CNPJ</Form.Label>
                            <Form.Control type="text" name="prop_cpfcnpj" value={formReboque.prop_cpfcnpj}
                                onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={14} />
                        </Form.Group>
                    </Col>

                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Inscrição Estadual</Form.Label>
                            <Form.Control type="text" name="ie" value={formReboque.prop_ie}
                                onKeyUp={handleNumberOnly} onChange={handleChange} maxLength={14}
                            />
                        </Form.Group>
                    </Col>
                </Row>

            </>

        )}

        <Row className="mb-3">
            <Col md>
                <Button variant="primary" onClick={handleAddReboque} size="sm">
                    <FontAwesomeIcon icon={faPlus} /> Adicionar Reboque
                </Button>
            </Col>
        </Row>

        <Row>
            <Col md>
                <h6>(3 no máximo)</h6>
                <Table striped bordered hover size="sm" responsive>
                    <thead className="table-light">
                        <tr>
                            <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                            <th>Placa</th>
                            <th>Tara(kg)</th>
                            <th>Capacidade(kg)</th>
                            <th>Nome Proprietario</th>
                            <th>CPF/CNPJ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listaReboques?.map((item: ReboqueInterface) => (
                            <tr key={item.placa}>
                                <td className="text-center">
                                    <a href="javasctipt:void(0)" className="text-danger"
                                        onClick={() => handleOpenModal(item.placa)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </a>
                                </td>
                                <td>{item.placa}</td>
                                <td>{item.tara}</td>
                                <td>{item.capKG}</td>
                                <td>{item.prop_xNome}</td>
                                <td>{item.prop_cpfcnpj}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Col>
        </Row>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleOpenModal}
            handleDelete={handleRemoveReboque}
            selectedObject={selected}
            id={selected}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}